// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import styles from './styles';

class CollectionArranged extends React.Component {
  state = {};

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <h6 className={classes.textTitle}>COLLECTION ARRANGED</h6>
      </div>
    );
  }
}

CollectionArranged.propTypes = {
  classes: PropTypes.object,
};

CollectionArranged.defaultProps = {
  classes: {},
};

export default withStyles(styles)(CollectionArranged);
